// plugins/loading.ts
export default defineNuxtPlugin(() => {
  const { show, hide } = useLoading()

  return {
    provide: {
      loading: {
        show,
        hide,
      },
    },
  }
})
